// libs
import { useState, useCallback, useEffect } from 'react';
import { getCouponV2 } from 'shared/api/cart';

import get from 'lodash/get';

import { COUPON_TYPE, CouponDetails, OfferDetails } from 'shared/layouts/Coupons/types';

// constants
import { EMPTY_COUPON_DATA } from 'shared/layouts/Coupons/constants';

function useFetchCouponDetails(showDetailCoupon: ProductOffers.ShowDetailCoupon) {
  const couponId = get(showDetailCoupon.coupon, 'couponDetails.couponId', '');
  const [currentCouponDetails, setCurrentCouponDetails] = useState<CouponDetails>({});
  const [currentOfferDetails, setCurrentOfferDetails] = useState<OfferDetails>({});
  const fetchCouponDetailsData = useCallback(() => {
    if (showDetailCoupon.type === COUPON_TYPE.COUPON) {
      getCouponV2(couponId)
        .then((data) => {
          setCurrentCouponDetails({
            ...data,
            discount: get(showDetailCoupon.coupon, 'couponDetails.discount'),
            expiryEpoch: get(showDetailCoupon.coupon, 'expiryEpoch'),
            disabled: showDetailCoupon.disabled,
          });
        })
        .catch(() => {
          setCurrentCouponDetails({
            ...EMPTY_COUPON_DATA,
            couponCode: '',
            discount: 0,
            disabled: showDetailCoupon.disabled,
          });
        });
    } else if (showDetailCoupon.type === COUPON_TYPE.OFFER) {
      const { offerId, title, description, label, offerDiscount, expiryEpoch } =
        showDetailCoupon.coupon;
      setCurrentOfferDetails({
        offerId,
        title,
        description,
        label,
        offerDiscount,
        expiryEpoch,
      });
    }
  }, [couponId, showDetailCoupon]);

  useEffect(() => fetchCouponDetailsData(), [fetchCouponDetailsData, showDetailCoupon]);
  return {
    currentCouponDetails,
    currentOfferDetails,
  };
}

export default useFetchCouponDetails;
